import React, { useRef } from 'react';
import { X } from 'lucide-react';
import styles from './TextInput.module.css';

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement> | { target: { value: string; name?: string } }) => void;
  showClearButton?: boolean;
  // id, disabled, className, placeholder, name sono già inclusi in InputHTMLAttributes
}

export const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  className,
  showClearButton = true,
  disabled,
  name,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClear = () => {
    // Simula un evento ChangeEvent per coerenza, sebbene onChange possa gestire anche un oggetto più semplice
    const syntheticEvent = {
      target: {
        value: '',
        name: name || '', // Includi il nome se disponibile
      },
      // Aggiungi altre proprietà dell'evento se necessario dalla tua implementazione di onChange
    } as React.ChangeEvent<HTMLInputElement>; // Cast per compatibilità, anche se la firma di onChange è stata allargata

    onChange(syntheticEvent);

    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const shouldShowClearButton = showClearButton && value && !disabled;

  return (
    <div className={styles.inputWrapper}>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        className={`${styles.textInput} ${className || ''} ${shouldShowClearButton ? styles.inputWithClear : ''}`}
        disabled={disabled}
        name={name}
        {...rest}
      />
      {shouldShowClearButton && (
        <button
          type="button"
          onClick={handleClear}
          className={styles.clearButton}
          aria-label="Clear input"
          disabled={disabled}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};